import { Axios, AxiosError, AxiosResponse } from 'axios'
import { RemoteConfig } from './remote.config'

export class LoginData {
	email?: string;
	phone?: string;
	password: string;

	constructor(password: string, email?: string, phone?: string) {
		this.password = password;
		this.email = email;
		this.phone = phone;
	}
}

export type LoginCallback = (resp?: AxiosResponse, err?: AxiosError) => void;

export const login = (data: LoginData, callback: LoginCallback) => {
	const client = new Axios();
	const url = new URL("/api/v0/auth/login", RemoteConfig.url);
	const result = client.post(url.toString(), JSON.stringify(data), {withCredentials: true, headers: {
		'Content-Type': 'application/json'
	  }}).then((resp) => {
		callback(resp)
	})
}
